if (!customElements.get('thumbnail-slider')) {
  class ThumbnailSlider extends HTMLElement {
    connectedCallback() {
      this.slider = this.querySelector('[id^="Slider-Thumbnails"]');
      this.items = Array.from(this.querySelectorAll('.thumbnail-list__item'));
      this.prevButton = this.querySelector('[data-thumbnail-nav="prev"]');
      this.nextButton = this.querySelector('[data-thumbnail-nav="next"]');

      if (!this.slider || !this.items.length) return;

      this.gap = this.getGap();
      this.onScroll = this.updateButtons.bind(this);
      this.onPrev = () => this.scrollByDirection(-1);
      this.onNext = () => this.scrollByDirection(1);

      this.prevButton?.addEventListener('click', this.onPrev);
      this.nextButton?.addEventListener('click', this.onNext);
      this.slider.addEventListener('scroll', this.onScroll, { passive: true });

      this.resizeObserver = new ResizeObserver(() => {
        this.gap = this.getGap();
        this.updateButtons();
      });
      this.resizeObserver.observe(this.slider);

      this.updateButtons();
    }

    disconnectedCallback() {
      this.prevButton?.removeEventListener('click', this.onPrev);
      this.nextButton?.removeEventListener('click', this.onNext);
      this.slider?.removeEventListener('scroll', this.onScroll);
      this.resizeObserver?.disconnect();
    }

    getGap() {
      const styles = window.getComputedStyle(this.slider);
      return parseFloat(styles.columnGap || styles.gap) || 10;
    }

    getItemStep() {
      if (!this.items[0]) return 0;
      return this.items[0].offsetWidth + this.gap;
    }

    getItemsPerView() {
      const step = this.getItemStep();
      if (!step) return 1;
      return Math.max(1, Math.floor((this.slider.clientWidth + this.gap) / step));
    }

    scrollByDirection(direction) {
      const step = this.getItemStep() * this.getItemsPerView();
      if (!step) return;

      const maxScroll = Math.max(0, this.slider.scrollWidth - this.slider.clientWidth);
      const target = Math.min(maxScroll, Math.max(0, this.slider.scrollLeft + direction * step));

      this.slider.scrollTo({
        left: target,
        behavior: 'smooth',
      });
    }

    isSlideVisible(element, offset = 0) {
      if (!element || !this.slider) return false;

      const lastVisible = this.slider.clientWidth + this.slider.scrollLeft - offset;
      return element.offsetLeft + element.clientWidth <= lastVisible && element.offsetLeft >= this.slider.scrollLeft;
    }

    updateButtons() {
      if (!this.prevButton || !this.nextButton) return;

      const needsNav = this.items.length > this.getItemsPerView();
      const maxScroll = Math.max(0, this.slider.scrollWidth - this.slider.clientWidth);
      const atStart = this.slider.scrollLeft <= 1;
      const atEnd = this.slider.scrollLeft >= maxScroll - 1;

      this.prevButton.hidden = !needsNav;
      this.nextButton.hidden = !needsNav;
      this.prevButton.disabled = !needsNav || atStart;
      this.nextButton.disabled = !needsNav || atEnd;
    }
  }

  customElements.define('thumbnail-slider', ThumbnailSlider);
}
